import React from 'react';
import { Tag } from '@ui/atoms/Tag';
/**
 * IP-14860 — "Assistant" column pill (was "Surface"). Solid pill per surface
 * (IPA / IA) matching the prototype's dark neutral chip. Bounded enum, so a
 * pill is the correct treatment (vs. the plain-text "Applies To" cell).
 */
export default function AssistantPill({ surfaces, t }) {
    return (React.createElement("span", { className: "tkb-assistant-pills" }, surfaces.map((surface) => (React.createElement(Tag, { key: surface, label: t(`rules.surface.${surface}`), variant: "gray", colorStyle: "solid", size: "base", readOnly: true, className: "tkb-assistant-pill" })))));
}
